import ActiveSlider from './ActiveSlider'

export default function ThreeBlocks(props) {
    const { isEnglish } = props

    const features = [
        {
            title: isEnglish ? 'Guaranteed Work' : 'Plannings remplis',
            text:
                isEnglish ?
                    "With increasing needs and not enough doctors, France needs more practitioners to keep up. You're guaranteed a full agenda from day one should you decide to join us."
                    :
                    "Avec des besoins très importants et une offre de santé encore trop faible, la région Centre a besoin de plus de médecins. Vous avez la garantie d'un agenda rempli et qualitatif dès le premier jour d'activité.",
            emoji: '📋',
        },
        {
            title: isEnglish ? 'Quality Healthcare' : "Priorité qualité",
            text:
                isEnglish ?
                    'Our doctors work in modern clinics and handle a wide range of treatments, guiding patients towards the best care. This is the ideal place to grow professionally and learn new skills.'
                    :
                    "Nos médecins travaillent dans des cliniques bien équipées et réalisent une large gamme de soins, guidant les patients vers le traitement le plus adapté. C'est l'endroit idéal pour vous développer et acquérir de nouvelles compétences.",
            emoji: '🏥',
        },
        {
            title: isEnglish ? 'Rewarding Careers' : "Carrières enrichissantes",
            text:
                isEnglish ?
                    "You worked hard to become a doctor? Make the choice to upgrade your career in France. Our doctors earn great money on normal working hours. You could too."
                    :
                    "Vous avez travaillé dur pour devenir médecin ? Faites le choix d'accélerer votre carrière avec Neomed. Nos praticiens ont d'excellents revenus en horaires normaux. Pourquoi pas vous?",
            emoji: '🚀',
        },
    ]

    return (
        <div className="bg-white">
            <div className="relative overflow-hidden pt-12 md:pt-0 shadow-2xl rounded-3xl md:px-16" style={{ backgroundColor: '#111827' }}>
                <div className="mx-auto text-center lg:mx-0 lg:flex-auto lg:text-left pt-8 pb-24 md:pt-24 md:pb-32">
                    <h2 className="text-2xl sm:text-3xl px-8 md:px-0 leading-snug text-start md:text-4xl font-bold text-white">
                        {isEnglish ? 'WHY CHOOSE NEOMED?' : 'POURQUOI CHOISIR NEOMED?'}
                    </h2>
                    <div className="mt-12">
                        {window.innerWidth > 768 ?
                            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-6 lg:max-w-none lg:grid-cols-3">
                                {features.map((feature) => (
                                    <div key={feature.title} className="group relative px-6 py-8 md:px-8 md:py-10 flex flex-col justify-start items-start bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 transition-all duration-300 hover:bg-white/10 hover:scale-[1.02] hover:border-white/20">
                                        <span className="text-3xl mb-4">{feature.emoji}</span>
                                        <h4 className="text-xl md:text-2xl font-bold text-white">{feature.title}</h4>
                                        <dd className="mt-3 text-sm md:text-base md:leading-7 leading-6 text-gray-300">{feature.text}</dd>
                                    </div>
                                ))}
                            </dl>
                            :
                            <ActiveSlider
                                data={features}
                                slides={1}
                                slidesPerView={1.15}
                                type="fluid"
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
